<ng-template #userInactivityDialog let-dialogRef let-dialogData="data">
  <mb-dialog class="mb-dialog-custom">
    <mb-dialog-header>
      <div class="mb-dialog-header-custom">
        <span class="text" i18n="@@promotion__on-time">¡Todavía estas a tiempo!</span>
        <mb-icon (click)="dialogRef.close()" class="close" icon="close"></mb-icon>
      </div>
    </mb-dialog-header>
    <mb-dialog-body>
      <div class="mb-dialog-body-custom">
        <div class="user-inactivity-body-container">
          @if (dialogData.hotel?.images?.length > 0) {
            <img backgroundImage [brand]="brand"
              [src]='resizedUrl + imageUrl' class="user-inactivity-body-container__left" />
          } @else {
            <div class="user-inactivity-body-container__left"
              [ngClass]="'user-inactivity-body-container--no-image-'+ brand"></div>
          }
          <div class="user-inactivity-body-container__right">
            <span class="user-inactivity-body-container__right__title" i18n="@@promotion__offer">¡APROVECHÁ ESTA OFERTA
              ANTES DE QUE SE AGOTE!</span>
            <p class="user-inactivity-body-container__right__name">{{ dialogData.hotel.name }}</p>
            <div class="user-inactivity-body-container__right__subtitle-content">
              <div>
                <mb-stars-rating [rating]="dialogData.hotel.stars"></mb-stars-rating>
                <div class="user-inactivity-body-container__right__subtitle-content__amenities-list">
                  @for (amenity of $any(dialogData).hotel.amenities | slice:0:6; track amenity) {
                    <ng-template #amenityTooltip>
                      {{$any(amenity).description}}
                    </ng-template>
                    <mb-icon class="icon" [icon]="$any(amenity).icon" [mb-tooltip]="amenityTooltip" mbTooltipColor="dark"
                      mbTooltipPosition="below"></mb-icon>
                  }
                </div>
              </div>
              <div class='user-inactivity-body-container__right__subtitle-content--right-align'>
                @if (dialogData.hotel.rate.price.discount.percentage >= 5 && dialogData.hotel.rate.price.discount.amount) {
                  <mb-advice color="success" align="right">
                    <span>{{ dialogData.hotel.rate.price.discount.percentage }}% OFF</span>
                  </mb-advice>
                }
              </div>
            </div>
            <button mb-button mb-button-small variant="principal" color="primary" (click)="detailRedirect()"
              i18n='@@hotel__see'>Ver alojamiento</button>
            <span class="user-inactivity-body-container__right__lastest-rooms" i18n="@@rooms__last-quantity">Últimas {{
              dialogData.hotel.rate.latest_rooms }} habitaciones</span>
          </div>
        </div>
      </div>
    </mb-dialog-body>
  </mb-dialog>
</ng-template>